import React from 'react';
import ReactECharts from 'echarts-for-react';
import { Card, Row, Col, Empty } from 'antd';

const WAN = v => (Math.abs(v) >= 10000 ? `${(v / 10000).toFixed(1)}万` : v);
const shortName = name => (name && name.length > 12 ? `${name.slice(0, 12)}…` : name);

function ChartCard({ title, option, empty, height = 280 }) {
  return (
    <Card size="small" title={title} style={{ height: '100%' }}>
      {empty
        ? <Empty description="暂无数据" style={{ padding: '60px 0' }} />
        : <ReactECharts option={option} style={{ height }} notMerge lazyUpdate />}
    </Card>
  );
}

export default function Charts({ summary }) {
  if (!summary) return null;
  const { trend, byDept, topSuppliers, topMaterials } = summary;

  const trendOption = {
    tooltip: {
      trigger: 'axis',
      valueFormatter: v => (v === null || v === undefined ? '-' : `¥${Number(v).toLocaleString()}`),
    },
    legend: { data: [ '本期采购金额', '去年同期' ], bottom: 0 },
    grid: { left: 10, right: 20, top: 30, bottom: 40, containLabel: true },
    xAxis: { type: 'category', data: trend.map(t => t.ym) },
    yAxis: { type: 'value', axisLabel: { formatter: WAN } },
    series: [
      { name: '本期采购金额', type: 'bar', barMaxWidth: 36, itemStyle: { color: '#1677ff' }, data: trend.map(t => t.amount) },
      { name: '去年同期', type: 'line', smooth: true, connectNulls: true, itemStyle: { color: '#faad14' }, data: trend.map(t => t.lastYearAmount) },
    ],
  };

  const deptOption = {
    tooltip: { trigger: 'item', formatter: p => `${p.name}<br/>¥${Number(p.value).toLocaleString()} (${p.percent}%)` },
    legend: { bottom: 0, type: 'scroll' },
    series: [{
      type: 'pie',
      radius: [ '40%', '65%' ],
      center: [ '50%', '45%' ],
      data: byDept.map(d => ({ name: d.name, value: d.amount })),
      label: { formatter: '{b}\n{d}%' },
    }],
  };

  const supplierOption = {
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, valueFormatter: v => `¥${Number(v).toLocaleString()}` },
    grid: { left: 10, right: 90, top: 10, bottom: 10, containLabel: true },
    xAxis: { type: 'value', axisLabel: { formatter: WAN } },
    yAxis: {
      type: 'category',
      data: topSuppliers.map(s => shortName(s.supplierName)).reverse(),
      axisLabel: { fontSize: 11 },
    },
    series: [{
      type: 'bar',
      barMaxWidth: 16,
      itemStyle: { color: '#52c41a' },
      data: topSuppliers.map(s => s.amount).reverse(),
      label: { show: true, position: 'right', fontSize: 11, formatter: p => `¥${Number(p.value).toLocaleString()}` },
    }],
  };

  const materialOption = {
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, valueFormatter: v => `¥${Number(v).toLocaleString()}` },
    grid: { left: 10, right: 90, top: 10, bottom: 10, containLabel: true },
    xAxis: { type: 'value', axisLabel: { formatter: WAN } },
    yAxis: {
      type: 'category',
      data: topMaterials.map(m => shortName(m.materialName || m.materialNumber)).reverse(),
      axisLabel: { fontSize: 11 },
    },
    series: [{
      type: 'bar',
      barMaxWidth: 16,
      itemStyle: { color: '#722ed1' },
      data: topMaterials.map(m => m.amount).reverse(),
      label: { show: true, position: 'right', fontSize: 11, formatter: p => `¥${Number(p.value).toLocaleString()}` },
    }],
  };

  return (
    <Row gutter={[ 16, 16 ]}>
      <Col xs={24} lg={12}>
        <ChartCard title="月度采购金额趋势（含同比）" option={trendOption} empty={!trend.length} />
      </Col>
      <Col xs={24} lg={12}>
        <ChartCard title="部门采购占比" option={deptOption} empty={!byDept.length} />
      </Col>
      <Col xs={24} lg={12}>
        <ChartCard title="供应商 TOP10 采购金额" option={supplierOption} empty={!topSuppliers.length} />
      </Col>
      <Col xs={24} lg={12}>
        <ChartCard title="物料 TOP10 采购金额" option={materialOption} empty={!topMaterials.length} />
      </Col>
    </Row>
  );
}
